export default __webpack_public_path__ + "static/form-grouping-dont-d7ebb9c5ae81285bda5e8c20e44f578ed99c70a949139737863f14773fd57e87.png";